import { t } from '../../i18n';
import type { MailboxTab, SocialTab, UserMenuTab } from './types';

type StyleMap = Partial<CSSStyleDeclaration>;

const TOP_ACTIVE: StyleMap = {
    color: '#f8fafc',
    borderBottom: '2px solid #60a5fa',
    background: 'rgba(96, 165, 250, 0.1)',
    fontWeight: 'bold',
};

const TAB_ACTIVE: StyleMap = {
    color: '#60a5fa',
    borderBottom: '2px solid #60a5fa',
    background: 'rgba(96, 165, 250, 0.1)',
    fontWeight: 'bold',
};

const INACTIVE: StyleMap = {
    color: '#6b7280',
    borderBottom: '2px solid transparent',
    background: 'transparent',
    fontWeight: 'normal',
};

const UNREAD_INACTIVE: StyleMap = {
    color: '#fbbf24',
    borderBottom: '2px solid transparent',
    background: 'transparent',
    fontWeight: 'bold',
};

export interface UserMenuTabElements {
    socialSubHeader: HTMLDivElement;
    mailboxSubHeader: HTMLDivElement;
    tradesSubHeader: HTMLDivElement;
    socialsTopTab: HTMLButtonElement;
    mailboxTopTab: HTMLButtonElement;
    tradesTopTab: HTMLButtonElement;
    dungeonsTopTab: HTMLButtonElement;
    friendsTab: HTMLButtonElement;
    guildTab: HTMLButtonElement;
    messagesTab: HTMLButtonElement;
    incomingTradesTab: HTMLButtonElement;
    outgoingTradesTab: HTMLButtonElement;
}

export function setSubHeaderVisibility(elements: UserMenuTabElements, activeMenuTab: UserMenuTab): void {
    elements.socialSubHeader.style.display = activeMenuTab === 'Socials' ? 'flex' : 'none';
    elements.mailboxSubHeader.style.display = activeMenuTab === 'Mailbox' ? 'flex' : 'none';
    elements.tradesSubHeader.style.display = activeMenuTab === 'Trades' ? 'flex' : 'none';
}

export function updateTopTabStyles(
    elements: UserMenuTabElements,
    activeMenuTab: UserMenuTab,
    unreadMessages: number,
    unreadIncomingTrades: number
): void {
    Object.assign(elements.socialsTopTab.style, activeMenuTab === 'Socials' ? TOP_ACTIVE : INACTIVE);

    const hasMailboxUnread = unreadMessages > 0;
    Object.assign(
        elements.mailboxTopTab.style,
        activeMenuTab === 'Mailbox' ? TOP_ACTIVE : (hasMailboxUnread ? UNREAD_INACTIVE : INACTIVE)
    );
    Object.assign(
        elements.tradesTopTab.style,
        activeMenuTab === 'Trades' ? TOP_ACTIVE : (unreadIncomingTrades > 0 ? UNREAD_INACTIVE : INACTIVE)
    );

    Object.assign(elements.dungeonsTopTab.style, activeMenuTab === 'Dungeons' ? TOP_ACTIVE : INACTIVE);
}

export function updateSocialTabStyles(
    elements: UserMenuTabElements,
    activeSocialTab: SocialTab
): void {
    Object.assign(elements.friendsTab.style, activeSocialTab === 'Friends' ? TAB_ACTIVE : INACTIVE);
    Object.assign(elements.guildTab.style, activeSocialTab === 'Guild' ? TAB_ACTIVE : INACTIVE);
}

export function updateMailboxTabStyles(
    elements: UserMenuTabElements,
    activeMailboxTab: MailboxTab,
    unreadMessages: number,
    unreadIncomingTrades: number
): void {
    Object.assign(
        elements.messagesTab.style,
        activeMailboxTab === 'Messages' ? TAB_ACTIVE : (unreadMessages > 0 ? UNREAD_INACTIVE : INACTIVE)
    );

    Object.assign(
        elements.incomingTradesTab.style,
        activeMailboxTab === 'IncomingTrades' ? TAB_ACTIVE : (unreadIncomingTrades > 0 ? UNREAD_INACTIVE : INACTIVE)
    );

    Object.assign(elements.outgoingTradesTab.style, activeMailboxTab === 'OutgoingTrades' ? TAB_ACTIVE : INACTIVE);
}

export function updateMailboxTabLabels(
    elements: UserMenuTabElements,
    unreadMessages: number,
    unreadIncomingTrades: number
): void {
    const messagesLabel = t('userMenu.mailbox.tabs.messages');
    const incomingTradesLabel = t('userMenu.mailbox.tabs.incomingTrades');
    const outgoingTradesLabel = t('userMenu.mailbox.tabs.outgoingTrades');
    const mailboxLabel = t('userMenu.tabs.mailbox');
    const tradesLabel = t('userMenu.tabs.trades');

    elements.messagesTab.textContent = unreadMessages > 0 ? `${messagesLabel} (${unreadMessages})` : messagesLabel;
    elements.incomingTradesTab.textContent = unreadIncomingTrades > 0
        ? `${incomingTradesLabel} (${unreadIncomingTrades})`
        : incomingTradesLabel;
    elements.outgoingTradesTab.textContent = outgoingTradesLabel;

    elements.mailboxTopTab.textContent = unreadMessages > 0 ? `${mailboxLabel} (${unreadMessages})` : mailboxLabel;
    elements.tradesTopTab.textContent = unreadIncomingTrades > 0 ? `${tradesLabel} (${unreadIncomingTrades})` : tradesLabel;
}
